import { createElement } from 'react'
import { JoyStep } from '@templates/Onboarding'

export const ONBOARDING_TITLE = 'Расскажем, как создать курс'

const STEP_TITLE = 'Создание курса'
const lines = (...items: string[]) =>
  createElement(
    'div',
    null,
    items.map((item) => createElement('div', { key: item }, item))
  )

export const ONBOARDING_STEPS: JoyStep[] = [
  {
    target: '#course-title-hours',
    title: STEP_TITLE,
    content: lines(
      'Укажите название курса',
      'и количество часов для его прохождения.'
    ),
  },
  {
    target: '#courseCategory',
    title: STEP_TITLE,
    content: lines(
      'Укажите категорию курса.',
      'Выберите категорию «Пожарная безопасность», чтобы курс попадал в Журнал учета противопожарных инструктажей.'
    ),
  },
  {
    target: '#mintrudDict',
    title: STEP_TITLE,
    content: lines(
      'Это значение используется для выгрузки в реестр минтруда.',
      'Если курс не планируется к выгрузке, оставьте поле пустым.',
      'В списке выводятся все возможные на данный момент курсы для выгрузки в реестр.'
    ),
  },
  {
    target: '#sortOrder',
    title: STEP_TITLE,
    content: lines(
      'Вы можете задавать пользовательскую сортировку курсов.',
      'Чем больше вы укажите значение для курса, тем выше он будет выводиться в общем списке.'
    ),
  },
  {
    target: '#electricalSafetyFirstGroup',
    title: STEP_TITLE,
    content: lines(
      'Активируйте чекбокс, если обучение по этому курсу должно попадать в Журнал присвоения I группы по электробезопасности.'
    ),
  },
  {
    target: '#course-availability-block',
    title: STEP_TITLE,
    content: lines(
      'Выберите для каких компаний/филиалов будет доступно обучение по этому курсу.',
      'Если нужен доступ для всей компании, то оставьте поле «Филиал» пустым.'
    ),
  },
  {
    target: '#modal-save',
    title: 'Сохраните курс',
    content: '',
  },
]
